var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 45,
    viewBox: "0 0 45 45",
    width: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 22.5c0-12.4264075 10.0735925-22.5 22.5-22.5s22.5 10.0735925 22.5 22.5-10.0735925 22.5-22.5 22.5-22.5-10.0735925-22.5-22.5z",
    fill: "#3b5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.0952079 34.9795094v-12.2411879h3.3791032l.4478042-4.2183811h-3.8269074l.0057411-2.1113404c0-1.1002188.1045355-1.6897411 1.6847674-1.6897411h2.1124777v-4.2188589h-3.3795816c-4.0594211 0-5.4882321 2.0463687-5.4882321 5.4877174v2.5327007h-2.5303804v4.2183811h2.5303804v12.2407102z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFacebook);
export default __webpack_public_path__ + "static/media/share_facebook.ce597123f5d88d09c5daf471fa6e4cab.svg";
export { ForwardRef as ReactComponent };